<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    :persistent="true"
  >
    <v-app-bar
      dark
      color="black"
      fixed
      dense
    >
      <!-- <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>-->
      <v-toolbar-title>
        {{project.Name}}
        ({{project.Status}})
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        icon
        dark
        @click="close"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <template v-slot:extension>
        <v-tabs
          v-model="tabIndex"
          fixed-tabs
          color="white"
          background-color="black"
          slider-color="white"
          dark
        >
          <v-tab>資訊</v-tab>
          <v-tab>任務</v-tab>
          <v-tab>發票</v-tab>
          <v-tab>結案</v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <!-- 資訊 -->
    <v-card
      v-show="tabIndex == 0"
      style="padding-top: 96px !important;overflow-y:auto;"
      tile
    >
      <v-list three-line>
        <v-row>
          <v-col
            cols="12"
            lg="3"
            md="4"
            sm="6"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>案號</v-list-item-title>
                <v-list-item-subtitle>{{fullProjectID}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="4"
            sm="6"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>負責人</v-list-item-title>
                <v-list-item-subtitle>{{manager.Profile.Name}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="4"
            sm="6"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>金額</v-list-item-title>
                <v-list-item-subtitle>
                  <span :class="{'deleted': (project.Status == '執行中' || project.Status == '已結案' || project.Status == '已完成') && project.FinalAmount > 0}">
                    {{project.Amount | amountFormat}}
                  </span>
                  <span v-if="(project.Status == '執行中' || project.Status == '已結案' || project.Status == '已完成') && project.FinalAmount > 0">
                    ->
                    {{project.FinalAmount | amountFormat}}
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            md="12"
            sm="12"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>說明</v-list-item-title>
                <v-list-item-subtitle style="white-space: initial">{{project.Description}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-list>

      <v-divider></v-divider>

      <v-list
        three-line
        subheader
      >
        <v-subheader>客戶資料</v-subheader>
        <v-row>
          <v-col
            cols="12"
            lg="3"
            md="4"
            sm="4"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>地區</v-list-item-title>
                <v-list-item-subtitle>{{county.Name}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="4"
            sm="4"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>客戶</v-list-item-title>
                <v-list-item-subtitle>{{clientCounty.Name}}{{client.Name}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="4"
            sm="4"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>科室</v-list-item-title>
                <v-list-item-subtitle>{{project.ClientDepartment}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="12"
            sm="12"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>聯繫窗口</v-list-item-title>
                <v-list-item-subtitle style="white-space: initial">{{project.ClientContact}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-list>

      <v-fab-transition
        v-if="canEditProject">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              @click="showProjectEditor"
              v-on="on"
              v-show="tabIndex == 0"
              color="black"
              class="v-btn--fixed"
              dark
              absolute
              right
              bottom
              fab
              style="bottom:28px;">
              <v-icon>edit</v-icon>
            </v-btn>
          </template>
          <span>編輯專案</span>
        </v-tooltip>
      </v-fab-transition>
    </v-card>

    <!-- 任務 -->
    <project-dialog-task
      :project-id="id"
      :isShow="tabIndex == 1"
      style="padding-top: 96px !important;overflow-y:auto;"
    />

    <!-- 發票 -->
    <project-dialog-receipt
      :project-id="id"
      :isShow="tabIndex == 2"
      style="padding-top: 96px !important;overflow-y:auto;"
    />

    <!-- 結案 -->
    <v-card
      v-show="tabIndex == 3"
      style="padding-top: 96px !important;overflow-y:auto;"
      tile
    >

      <!-- 結案紀錄 -->
      <v-list
        three-line
        subheader
      >
        <v-subheader>結案紀錄</v-subheader>
        <v-row>
          <v-col cols="12">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>結案存檔路徑</v-list-item-title>
                <v-list-item-subtitle>{{project.CloseRecord}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>檢討與說明</v-list-item-title>
                <v-list-item-subtitle style="white-space: initial">{{project.ReviewNote}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="6"
            lg="6"
            md="6"
            sm="12"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>結案簽核</v-list-item-title>
                <v-list-item-subtitle>{{closeSigners}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-list>

      <v-fab-transition v-if="canCloseProject && !hadSignClosing">
        <v-btn
          @click="confirmCloseProject"
          v-show="tabIndex == 3"
          color="black"
          dark
          absolute
          right
          bottom
          fab
          style="bottom:28px;"
        >
          結案
        </v-btn>
      </v-fab-transition>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

    <task-working-item-detail-dialog
      v-if="$store.state.UI.dialog.taskWorkingItemDetailInProject.isShow"
      v-model="$store.state.UI.dialog.taskWorkingItemDetailInProject.isShow"
      :is-view-project-button-shown="false"
      :id="$store.state.UI.dialog.taskWorkingItemDetailInProject.id"
    />
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import filterMixin from "@/data/filters/filter-mixin.vue";
import ProjectDialogTask from "./project-dialog-task.vue";
import ProjectDialogReceipt from "./project-dialog-receipt.vue";
import TaskWorkingItemDetailDialog from "@/ui/project/task/task-working-item-detail-dialog.vue";
export default {
  mixins: [filterMixin],
  components: { ProjectDialogReceipt, ProjectDialogTask, TaskWorkingItemDetailDialog },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    id: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    tabIndex: 0
  }),
  computed: {
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    project() {
      return this.$store.state.project.list.find(o => o.ID == this.id) || {};
    },
    // 資訊
    fullProjectID() {
      var s = String(this.project.ID);
      while (s.length < 8) s = "0" + s;
      return this.project.Source + s;
    },
    client() {
      return (
        this.$store.state.client.list.find(
          o => o.ID === this.project.ClientID
        ) || {}
      );
    },
    clientCounty() {
      return (
        this.$store.state.county.list.find(
          o => o.ID === this.client.CountyID
        ) || {}
      );
    },
    manager() {
      return this.users.find(o => o.ID == this.project.ManagerID) || {Profile:{}};
    },
    county() {
      return (
        this.$store.state.county.list.find(
          o => o.ID === this.project.CountyID
        ) || {}
      );
    },
    // 結案
    closeSigners() {
      if (!this.project.CloseSignerIDs) return "";
      let defaultUser = { Profile: { Name: "unknown" } };
      return this.project.CloseSignerIDs.map(
        id => ((this.users.find(o => o.ID == id) || defaultUser) || {Profile:{}}).Profile.Name
      ).join(", ");
    },
    hadSignClosing() {
      return (
        this.project.CloseSignerIDs &&
        this.project.CloseSignerIDs.includes(this.me.ID)
      );
    },
    ...mapGetters(["canCloseProject", "me", "users", "canEditProject",])
  },
  methods: {
    // 結案
    confirmCloseProject() {
      if (confirm("確定簽核結案?")) this.closeProject();
    },
    closeProject() {
      this.isLoading = true;
      this.$services.project
        .sign(this, this.project.ID)
        .then(() => {
          this.$set(
            this.project,
            "CloseSignerIDs",
            (this.project.CloseSignerIDs || []).concat([this.me.ID])
          );
          alert("簽核成功!!");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$emit("close");
    },
    showProjectEditor () {
      this.$store.state.UI.dialog.project.isShow = false;
      this.$store.state.UI.dialog.projectEditor.id = this.project.ID;
      this.$store.state.UI.dialog.projectEditor.isShow = true;
      // this.$router.push({
      //   name: "project-editor",
      //   params: { id: this.projectId }
      // });
      // this.close()
    }
  },
  watch: {
    isShowDialog(val) {
      if (val) {
        var tabIndex = 0;
        if (this.$route.hash == "#tasks") tabIndex = 1;
        if (this.$store.state.UI.dialog.project.defaultOpenTaskTab) {
          tabIndex = 1;
          this.$store.state.UI.dialog.project.defaultOpenTaskTab = false
        }
        this.tabIndex = tabIndex;
      }
    }
  }
};
</script>

<style scoped>
.deleted {
  text-decoration: line-through;
}
</style>